angular.module('DoohApps').config(['$routeProvider', 'DoohLazyLoadProvider', 'DoohConfigProvider', 'Routes',
    function ($routeProvider, DoohLazyLoadProvider, DoohConfigProvider, Routes) {
    var controllerSuffix = 'Controller';

    var doohLazyLoad = DoohLazyLoadProvider.$get();
    var doohConfig = DoohConfigProvider.$get();

    Routes.forEach((routeElement) => {
        $routeProvider.when(routeElement.route, {
            controller: routeElement.controller + controllerSuffix,
            templateUrl: routeElement.templateUrl + '?v=' + doohConfig.version,
            navTabName: routeElement.tabName,
            resolve: doohLazyLoad.loadController(routeElement.controller)
        });
    });

    $routeProvider.otherwise({ redirectTo: '/AppStore' });
}
]);